import { REJECTION_REASONS_FEEDBACK } from './RejectionReasons';

/**
 * This map is used to map events which are set in db
 */
export const TRACKING_EVENTS = {
    UPLOAD_JOB_DESCRIPTION: 'UPLOAD_JOB_DESCRIPTION',
    CREATE_JOB_DESCRIPTION: 'CREATE_JOB_DESCRIPTION',
    UPLOAD_JOB_SUCCESS: 'UPLOAD_JOB_SUCCESS',
    CLONE_JOB_SUCCESS: 'CLONE_JOB_SUCCESS',
    SAMPLES_LINKEDIN_SAMPLES_ADDED: 'SAMPLES_LINKEDIN_SAMPLES_ADDED',
    CALIBRATION_FINISHED: 'CALIBRATION_FINISHED',
    EDIT_JOB_NEXT: 'EDIT_JOB_NEXT',
    REVIEW_THUMBS_UP: 'REVIEW_THUMBS_UP',
    REVIEW_THUMBS_DOWN: 'REVIEW_THUMBS_DOWN',
    BULK_REVIEW_THUMBS_UP: 'BULK_REVIEW_THUMBS_UP',
    BULK_REVIEW_THUMBS_DOWN: 'BULK_REVIEW_THUMBS_DOWN',
    REVIEW_AUTO_ASSIST_ON: 'REVIEW_AUTO_ASSIST_ON',
    CONTACT_CANDIDATE_SUBMIT: 'CONTACT_CANDIDATE_SUBMIT',
    CONTACT_AUTO_ASSIST_ON: 'CONTACT_AUTO_ASSIST_ON',
    EDIT_JOB: 'EDIT_JOB',
    REVIEW_REJECT_REASONS_DONT_SHOW: 'REVIEW_REJECT_REASONS_DONT_SHOW',
    [REJECTION_REASONS_FEEDBACK.JOB_TITLE]: REJECTION_REASONS_FEEDBACK.JOB_TITLE,
    [REJECTION_REASONS_FEEDBACK.SKILLS]: REJECTION_REASONS_FEEDBACK.SKILLS,
    [REJECTION_REASONS_FEEDBACK.EMPLOYER]: REJECTION_REASONS_FEEDBACK.EMPLOYER,
    [REJECTION_REASONS_FEEDBACK.INDUSTRY]: REJECTION_REASONS_FEEDBACK.INDUSTRY,
    [REJECTION_REASONS_FEEDBACK.LOCATION]: REJECTION_REASONS_FEEDBACK.LOCATION,
    [REJECTION_REASONS_FEEDBACK.RELEVANT_EXPERIENCE]: REJECTION_REASONS_FEEDBACK.RELEVANT_EXPERIENCE,
    [REJECTION_REASONS_FEEDBACK.SENIORITY]: REJECTION_REASONS_FEEDBACK.SENIORITY,
    [REJECTION_REASONS_FEEDBACK.EDUCATION]: REJECTION_REASONS_FEEDBACK.EDUCATION,
    [REJECTION_REASONS_FEEDBACK.LANGUAGES]: REJECTION_REASONS_FEEDBACK.LANGUAGES,
    [REJECTION_REASONS_FEEDBACK.LACK_OF_INFORMATION]: REJECTION_REASONS_FEEDBACK.LACK_OF_INFORMATION,
    [REJECTION_REASONS_FEEDBACK.OTHER]: REJECTION_REASONS_FEEDBACK.OTHER,
    [REJECTION_REASONS_FEEDBACK.ALREADY_REVIEWED]: REJECTION_REASONS_FEEDBACK.ALREADY_REVIEWED,
    [REJECTION_REASONS_FEEDBACK.PREVIOUS_JOB_TITLES]: REJECTION_REASONS_FEEDBACK.PREVIOUS_JOB_TITLES,
    [REJECTION_REASONS_FEEDBACK.MANAGERIAL_EXPERIENCE]: REJECTION_REASONS_FEEDBACK.MANAGERIAL_EXPERIENCE,
    [REJECTION_REASONS_FEEDBACK.AVERAGE_TENURE]: REJECTION_REASONS_FEEDBACK.AVERAGE_TENURE,
    [REJECTION_REASONS_FEEDBACK.COMPANY_SIZE]: REJECTION_REASONS_FEEDBACK.COMPANY_SIZE,
    [REJECTION_REASONS_FEEDBACK.SCHOOLS]: REJECTION_REASONS_FEEDBACK.SCHOOLS,
    REVIEW_TAB_SELECTED: 'REVIEW_TAB_SELECTED',
    REVIEW_CANDIDATE_CLICKED: 'REVIEW_CANDIDATE_CLICKED',
    INTERVIEW_TAB_SELECTED: 'INTERVIEW_TAB_SELECTED',
    CAMPAIGN_ON: 'CAMPAIGN_ON',
    CAMPAIGN_OFF: 'CAMPAIGN_OFF',
    EDIT_JOB_SELECTED: 'EDIT_JOB_SELECTED',
    DATA_ANALYTICS_SELECTED: 'DATA_ANALYTICS_SELECTED',
    DIVERSITY_OPTIMIZER_SELECTED: 'DIVERSITY_OPTIMIZER_SELECTED',
    PERFORMANCE_REPORT_SELECTED: 'PERFORMANCE_REPORT_SELECTED',
    DIVERSITY_OPTIMIZED_FIRST_APPLIED: 'DIVERSITY_OPTIMIZED_FIRST_APPLIED',
    DIVERSITY_OPTIMIZED_APPLIED: 'DIVERSITY_OPTIMIZED_APPLIED',
    DIVERSITY_RECOMMENDATIONS_CHANGED: 'DIVERSITY_RECOMMENDATIONS_CHANGED',

    QUALIFIED_CANDIDATE_MOVED_TO_INTERESTED: 'QUALIFIED_CANDIDATE_MOVED_TO_INTERESTED',
    QUALIFIED_CANDIDATE_MOVED_TO_INTERVIEW: 'QUALIFIED_CANDIDATE_MOVED_TO_INTERVIEW',
    QUALIFIED_CANDIDATE_MOVED_TO_CONTACTED: 'QUALIFIED_CANDIDATE_MOVED_TO_CONTACTED',
    QUALIFIED_CANDIDATE_MOVED_TO_REVIEW: 'QUALIFIED_CANDIDATE_MOVED_TO_REVIEW',
    CONTACTED_CANDIDATE_MOVED_TO_INTERVIEW: 'CONTACTED_CANDIDATE_MOVED_TO_INTERVIEW',
    CONTACTED_CANDIDATE_MOVED_TO_INTERESTED: 'CONTACTED_CANDIDATE_MOVED_TO_INTERESTED',
    CONTACTED_CANDIDATE_MOVED_TO_REVIEW: 'CONTACTED_CANDIDATE_MOVED_TO_REVIEW',
    INTERVIEW_CANDIDATE_MOVED_TO_INTERESTED: 'INTERVIEW_CANDIDATE_MOVED_TO_INTERESTED',
    INTERVIEW_CANDIDATE_MOVED_TO_CONTACTED: 'INTERVIEW_CANDIDATE_MOVED_TO_CONTACTED',
    INTERVIEW_CANDIDATE_MOVED_TO_REVIEW: 'INTERVIEW_CANDIDATE_MOVED_TO_REVIEW',
    INTERVIEW_CANDIDATE_MOVED_TO_HIRED: 'INTERVIEW_CANDIDATE_MOVED_TO_HIRED',
    INTERESTED_CANDIDATE_MOVED_TO_CONTACTED: 'INTERESTED_CANDIDATE_MOVED_TO_CONTACTED',
    INTERESTED_CANDIDATE_MOVED_TO_INTERVIEW: 'INTERESTED_CANDIDATE_MOVED_TO_INTERVIEW',
    INTERESTED_CANDIDATE_MOVED_TO_REVIEW: 'INTERESTED_CANDIDATE_MOVED_TO_REVIEW',

    EMPLOYER_REJECT_QUALIFIED_CANDIDATE: 'EMPLOYER_REJECT_QUALIFIED_CANDIDATE',
    EMPLOYER_REJECT_CONTACTED_CANDIDATE: 'EMPLOYER_REJECT_CONTACTED_CANDIDATE',
    EMPLOYER_REJECT_INTERESTED_CANDIDATE: 'EMPLOYER_REJECT_INTERESTED_CANDIDATE',
    EMPLOYER_REJECT_INTERVIEW_CANDIDATE: 'EMPLOYER_REJECT_INTERVIEW_CANDIDATE',

    EDIT_JOB_ADVANCED_CRITERIA_CLICKED: 'EDIT_JOB_ADVANCED_CRITERIA_CLICKED',
    POSITION_WIZARD_SAMPLES_SELECTED: 'POSITION_WIZARD_SAMPLES_SELECTED',
    POSITION_AI_SCORE_REACHED_SUFFICIENT_VALUE: 'POSITION_AI_SCORE_REACHED_SUFFICIENT_VALUE',
    POSITION_FEEDBACK_NEGATIVE_RATING_CANCEL: 'POSITION_FEEDBACK_NEGATIVE_RATING_CANCEL',
    POSITION_FEEDBACK_NEGATIVE_RATING_GO_TO_MANAGE_JOB: 'POSITION_FEEDBACK_NEGATIVE_RATING_GO_TO_MANAGE_JOB',

    CAMPAIGN_CHANGES_SAVED: 'CAMPAIGN_CHANGES_SAVED',
    CAMPAIGN_DETAILS_UPDATED: 'CAMPAIGN_DETAILS_UPDATED',
    CAMPAIGN_EMAILS_UPDATED: 'CAMPAIGN_EMAILS_UPDATED',
    CAMPAIGN_SET_AS_DEFAULT: 'CAMPAIGN_SET_AS_DEFAULT',
    CAMPAIGN_MESSAGES_EXPORTED_FROM_OTHER_POSITION: 'CAMPAIGN_MESSAGES_EXPORTED_FROM_OTHER_POSITION',

    DIVERSITY_REPORT_CLICKED: 'DIVERSITY_REPORT_CLICKED',
    DIVERSITY_REPORT_FILTER_CHANGED: 'DIVERSITY_REPORT_FILTER_CHANGED',
    DIVERSITY_REPORT_SAVE_PDF: 'DIVERSITY_REPORT_SAVE_PDF',
    DIVERSITY_REPORT_SHARE_URL: 'DIVERSITY_REPORT_SHARE_URL',
    DIVERSITY_REPORT_PRINT_REPORT: 'DIVERSITY_REPORT_PRINT_REPORT',

    REVIEW_MASS_BAD_RATING: 'REVIEW_MASS_BAD_RATING',

    EMAIL_EDITOR_SELECT_TEMPLATE: 'EMAIL_EDITOR_SELECT_TEMPLATE',
    EMAIL_EDITOR_ADD_RECIPIENT: 'EMAIL_EDITOR_ADD_RECIPIENT',
    EMAIL_EDITOR_DELETE_RECIPIENT: 'EMAIL_EDITOR_DELETE_RECIPIENT',
    EMAIL_EDITOR_SELECTED_AUTO_TEXT_SUBJECT: 'EMAIL_EDITOR_SELECTED_AUTO_TEXT_SUBJECT',
    EMAIL_EDITOR_SELECTED_AUTO_TEXT_BODY: 'EMAIL_EDITOR_SELECTED_AUTO_TEXT_BODY',
    EMAIL_EDITOR_CREATE_TEMPLATE: 'EMAIL_EDITOR_CREATE_TEMPLATE',
    EMAIL_EDITOR_UPDATE_TEMPLATE: 'EMAIL_EDITOR_UPDATE_TEMPLATE',
    EMAIL_EDITOR_DELETE_TEMPLATE: 'EMAIL_EDITOR_DELETE_TEMPLATE',
    EMAIL_EDITOR_SEND_EMAIL: 'EMAIL_EDITOR_SEND_EMAIL',

    LINKEDIN_EDITOR_SELECT_TEMPLATE: 'LINKEDIN_EDITOR_SELECT_TEMPLATE',
    LINKEDIN_EDITOR_ADD_RECIPIENT: 'LINKEDIN_EDITOR_ADD_RECIPIENT',
    LINKEDIN_EDITOR_DELETE_RECIPIENT: 'LINKEDIN_EDITOR_DELETE_RECIPIENT',
    LINKEDIN_EDITOR_SELECTED_AUTO_TEXT_SUBJECT: 'LINKEDIN_EDITOR_SELECTED_AUTO_TEXT_SUBJECT',
    LINKEDIN_EDITOR_SELECTED_AUTO_TEXT_BODY: 'LINKEDIN_EDITOR_SELECTED_AUTO_TEXT_BODY',
    LINKEDIN_EDITOR_CREATE_TEMPLATE: 'LINKEDIN_EDITOR_CREATE_TEMPLATE',
    LINKEDIN_EDITOR_UPDATE_TEMPLATE: 'LINKEDIN_EDITOR_UPDATE_TEMPLATE',
    LINKEDIN_EDITOR_DELETE_TEMPLATE: 'LINKEDIN_EDITOR_DELETE_TEMPLATE',
    LINKEDIN_EDITOR_SEND_EMAIL: 'LINKEDIN_EDITOR_SEND_EMAIL',

    IN_MAIL_EDITOR_SELECT_TEMPLATE: 'IN_MAIL_EDITOR_SELECT_TEMPLATE',
    IN_MAIL_EDITOR_ADD_RECIPIENT: 'IN_MAIL_EDITOR_ADD_RECIPIENT',
    IN_MAIL_EDITOR_SELECTED_AUTO_TEXT_SUBJECT: 'IN_MAIL_EDITOR_SELECTED_AUTO_TEXT_SUBJECT',
    IN_MAIL_EDITOR_SELECTED_AUTO_TEXT_BODY: 'IN_MAIL_EDITOR_SELECTED_AUTO_TEXT_BODY',
    IN_MAIL_EDITOR_DELETE_RECIPIENT: 'IN_MAIL_EDITOR_DELETE_RECIPIENT',
    IN_MAIL_EDITOR_CREATE_TEMPLATE: 'IN_MAIL_EDITOR_CREATE_TEMPLATE',
    IN_MAIL_EDITOR_UPDATE_TEMPLATE: 'IN_MAIL_EDITOR_UPDATE_TEMPLATE',
    IN_MAIL_EDITOR_DELETE_TEMPLATE: 'IN_MAIL_EDITOR_DELETE_TEMPLATE',
    IN_MAIL_EDITOR_SEND_EMAIL: 'IN_MAIL_EDITOR_SEND_EMAIL',

    RECOMMENDATIONS_TOGGLE_TURN_ON: 'RECOMMENDATIONS_TOGGLE_TURN_ON',
    RECOMMENDATIONS_TOGGLE_TURN_OFF: 'RECOMMENDATIONS_TOGGLE_TURN_OFF',
    RECOMMENDATIONS_CHECKBOX_TURN_OFF: 'RECOMMENDATIONS_CHECKBOX_TURN_OFF',
    RECOMMENDATIONS_AI_PANEL_COLLAPSED: 'RECOMMENDATIONS_AI_PANEL_COLLAPSED',
    RECOMMENDATIONS_AI_PANEL_EXPANDED: 'RECOMMENDATIONS_AI_PANEL_EXPANDED',
    RECOMMENDATIONS_POPUP_APPLIED: 'RECOMMENDATIONS_POPUP_APPLIED',
    RECOMMENDATIONS_POPUP_DISMISSED: 'RECOMMENDATIONS_POPUP_DISMISSED',
    RECOMMENDATIONS_SLIDER_OPEN: 'RECOMMENDATIONS_SLIDER_OPEN',

    DIVERSITY_FILTER_SELECTED_ALL: 'DIVERSITY_FILTER_SELECTED_ALL',
    DIVERSITY_FILTER_SELECTED_FEMALE: 'DIVERSITY_FILTER_SELECTED_FEMALE',
    DIVERSITY_FILTER_SELECTED_BLACK: 'DIVERSITY_FILTER_SELECTED_BLACK',
    DIVERSITY_FILTER_SELECTED_HISPANIC: 'DIVERSITY_FILTER_SELECTED_HISPANIC',
    DIVERSITY_FILTER_SELECTED_ASIAN: 'DIVERSITY_FILTER_SELECTED_ASIAN',
    DIVERSITY_FILTER_SELECTED_VETERAN: 'DIVERSITY_FILTER_SELECTED_VETERAN',

    GDPR_LOCATIONS_ADDED_TO_EXISTED_POSITION: 'GDPR_LOCATIONS_ADDED_TO_EXISTED_POSITION',
    GDPR_LOCATIONS_REMOVED_FROM_EXISTED_POSITION: 'GDPR_LOCATIONS_REMOVED_FROM_EXISTED_POSITION',
    GDPR_LOCATIONS_ADDED_TO_NEW_POSITION: 'GDPR_LOCATIONS_ADDED_TO_NEW_POSITION',
    CANDIDATE_CLICKED_ON_INTERESTED_BUTTON: 'CANDIDATE_CLICKED_ON_INTERESTED_BUTTON',

    CAMPAIGN_MANAGER_PAGE_OPENED: 'CAMPAIGN_MANAGER_PAGE_OPENED',
    CAMPAIGN_MANAGER_PAGE_ADVANCED_DETAILS_OPENED: 'CAMPAIGN_MANAGER_PAGE_ADVANCED_DETAILS_OPENED',
    CAMPAIGN_MANAGER_PAGE_ON_SEARCH_FOCUSED: 'CAMPAIGN_MANAGER_PAGE_ON_SEARCH_FOCUSED',
    CAMPAIGN_MANAGER_PAGE_SENDERS_FILTER_SELECTED: 'CAMPAIGN_MANAGER_PAGE_SENDERS_FILTER_SELECTED',
    CAMPAIGN_MANAGER_PAGE_STATUS_FILTER_SELECTED: 'CAMPAIGN_MANAGER_PAGE_STATUS_FILTER_SELECTED',
    CAMPAIGN_MANAGER_PAGE_SORT_BY_CAMPAIGN_NAME: 'CAMPAIGN_MANAGER_PAGE_SORT_BY_CAMPAIGN_NAME',
    CAMPAIGN_MANAGER_PAGE_SORT_BY_SENDER_NAME: 'CAMPAIGN_MANAGER_PAGE_SORT_BY_SENDER_NAME',
    CAMPAIGN_MANAGER_PAGE_SORT_BY_START_DATE: 'CAMPAIGN_MANAGER_PAGE_SORT_BY_START_DATE',
    CAMPAIGN_MANAGER_PAGE_EXPORT_TO_CSV: 'CAMPAIGN_MANAGER_PAGE_EXPORT_TO_CSV',
    CAMPAIGN_MANAGER_PAGE_SAVE_AS_PDF: 'CAMPAIGN_MANAGER_PAGE_SAVE_AS_PDF',
    CAMPAIGN_MANAGER_ADVANCED_DETAILS_PAGE_PAUSE_CAMPAIGN: 'CAMPAIGN_MANAGER_ADVANCED_DETAILS_PAGE_PAUSE_CAMPAIGN',
    CAMPAIGN_MANAGER_ADVANCED_DETAILS_PAGE_RESUME_CAMPAIGN: 'CAMPAIGN_MANAGER_ADVANCED_DETAILS_PAGE_RESUME_CAMPAIGN',
    CAMPAIGN_MANAGER_ADVANCED_DETAILS_PAGE_EDIT_CAMPAIGN: 'CAMPAIGN_MANAGER_ADVANCED_DETAILS_PAGE_EDIT_CAMPAIGN',
    EMPLOYER_POSITION_CANDIDATES_CLICK_ON_GET_TALENYA_CHROME_EXTENSION_BTN: 'EMPLOYER_POSITION_CANDIDATES_CLICK_ON_GET_TALENYA_CHROME_EXTENSION_BTN',
    EMPLOYER_POSITION_CANDIDATES_SEND_LINKEDIN_INVITE_REQUEST: 'EMPLOYER_POSITION_CANDIDATES_SEND_LINKEDIN_INVITE_REQUEST',
    EMPLOYER_POSITION_CANDIDATES_SEND_LINKEDIN_MESSAGE: 'EMPLOYER_POSITION_CANDIDATES_SEND_LINKEDIN_MESSAGE',
    EMPLOYER_POSITION_CANDIDATES_SELECT_LINKEDIN_CONTACT_CHANNEL: 'EMPLOYER_POSITION_CANDIDATES_SELECT_LINKEDIN_CONTACT_CHANNEL',
    EMPLOYER_POSITION_CANDIDATES_CLICK_ON_LOGIN_INTO_LINKEDIN: 'EMPLOYER_POSITION_CANDIDATES_CLICK_ON_LOGIN_INTO_LINKEDIN',
    EMPLOYER_POSITION_CANDIDATES_SEND_IN_MAIL_MESSAGE: 'EMPLOYER_POSITION_CANDIDATES_SEND_IN_MAIL_MESSAGE',
    EMPLOYER_POSITION_CANDIDATES_SELECT_IN_MAIL_CONTACT_CHANNEL: 'EMPLOYER_POSITION_CANDIDATES_SELECT_IN_MAIL_CONTACT_CHANNEL',
    CANDIDATE_CLICKED_ON_REJECT_BUTTON: 'CANDIDATE_CLICKED_ON_REJECT_BUTTON',
    EMPLOYER_POSITION_CANDIDATES_CONTACT_INFO_POPUP_OPENED: 'EMPLOYER_POSITION_CANDIDATES_CONTACT_INFO_POPUP_OPENED',
};

export const HOTJAR_TAGS = {
    UPLOAD_JOB: 'UPLOAD_JOB',
    CREATE_JOB: 'CREATE_JOB',
    CLONE_JOB: 'CLONE_JOB',
    REVIEW_TAB_CLICKED: 'REVIEW_TAB_CLICKED',
    THUMBS_UP: 'THUMBS_UP',
    THUMBS_DOWN: 'THUMBS_DOWN',
    BULK_REVIEW_THUMBS_UP: 'BULK_REVIEW_THUMBS_UP',
    BULK_REVIEW_THUMBS_DOWN: 'BULK_REVIEW_THUMBS_DOWN',
    CONTACT_MANUAL: 'CONTACT_MANUAL',
    CONTACT_AUTO: 'CONTACT_AUTO',
    INTERESTED_TAB_CLICKED: 'INTERESTED_TAB_CLICKED',
    INTERVIEW_TAB_CLICKED: 'INTERVIEW_TAB_CLICKED',
    MANAGE_JOB_CLICKED: 'MANAGE_JOB_CLICKED',
    DATA_ANALYTICS_CLICKED: 'DATA_ANALYTICS_CLICKED',
    DIVERSITY_AI_CLICKED: 'DIVERSITY_AI_CLICKED',
    DIVERSITY_APPLIED: 'DIVERSITY_APPLIED',
    [REJECTION_REASONS_FEEDBACK.JOB_TITLE]: REJECTION_REASONS_FEEDBACK.JOB_TITLE,
    [REJECTION_REASONS_FEEDBACK.SKILLS]: REJECTION_REASONS_FEEDBACK.SKILLS,
    [REJECTION_REASONS_FEEDBACK.EMPLOYER]: REJECTION_REASONS_FEEDBACK.EMPLOYER,
    [REJECTION_REASONS_FEEDBACK.INDUSTRY]: REJECTION_REASONS_FEEDBACK.INDUSTRY,
    [REJECTION_REASONS_FEEDBACK.LOCATION]: REJECTION_REASONS_FEEDBACK.LOCATION,
    [REJECTION_REASONS_FEEDBACK.RELEVANT_EXPERIENCE]: REJECTION_REASONS_FEEDBACK.RELEVANT_EXPERIENCE,
    [REJECTION_REASONS_FEEDBACK.SENIORITY]: REJECTION_REASONS_FEEDBACK.SENIORITY,
    [REJECTION_REASONS_FEEDBACK.EDUCATION]: REJECTION_REASONS_FEEDBACK.EDUCATION,
    [REJECTION_REASONS_FEEDBACK.LANGUAGES]: REJECTION_REASONS_FEEDBACK.LANGUAGES,
    [REJECTION_REASONS_FEEDBACK.LACK_OF_INFORMATION]: REJECTION_REASONS_FEEDBACK.LACK_OF_INFORMATION,
    [REJECTION_REASONS_FEEDBACK.OTHER]: REJECTION_REASONS_FEEDBACK.OTHER,
    [REJECTION_REASONS_FEEDBACK.ALREADY_REVIEWED]: REJECTION_REASONS_FEEDBACK.ALREADY_REVIEWED,
    [REJECTION_REASONS_FEEDBACK.PREVIOUS_JOB_TITLES]: REJECTION_REASONS_FEEDBACK.PREVIOUS_JOB_TITLES,
    [REJECTION_REASONS_FEEDBACK.MANAGERIAL_EXPERIENCE]: REJECTION_REASONS_FEEDBACK.MANAGERIAL_EXPERIENCE,
    [REJECTION_REASONS_FEEDBACK.AVERAGE_TENURE]: REJECTION_REASONS_FEEDBACK.AVERAGE_TENURE,
    [REJECTION_REASONS_FEEDBACK.COMPANY_SIZE]: REJECTION_REASONS_FEEDBACK.COMPANY_SIZE,
    [REJECTION_REASONS_FEEDBACK.SCHOOLS]: REJECTION_REASONS_FEEDBACK.SCHOOLS,
    CAMPAIGN_CHANGES_SAVED: 'CAMPAIGN_CHANGES_SAVED',
    CAMPAIGN_DETAILS_UPDATED: 'CAMPAIGN_DETAILS_UPDATED',
    CAMPAIGN_EMAILS_UPDATED: 'CAMPAIGN_EMAILS_UPDATED',
    CAMPAIGN_SET_AS_DEFAULT: 'CAMPAIGN_SET_AS_DEFAULT',
    CAMPAIGN_MESSAGES_EXPORTED_FROM_OTHER_POSITION: 'CAMPAIGN_MESSAGES_EXPORTED_FROM_OTHER_POSITION',

    DIVERSITY_REPORT_CLICKED: 'DIVERSITY_REPORT_CLICKED',
    DIVERSITY_REPORT_FILTER_CHANGED: 'DIVERSITY_REPORT_FILTER_CHANGED',
    DIVERSITY_REPORT_SAVE_PDF: 'DIVERSITY_REPORT_SAVE_PDF',
    DIVERSITY_REPORT_SHARE_URL: 'DIVERSITY_REPORT_SHARE_URL',
    DIVERSITY_REPORT_PRINT_REPORT: 'DIVERSITY_REPORT_PRINT_REPORT',

    EMAIL_EDITOR_SELECT_TEMPLATE: 'EMAIL_EDITOR_SELECT_TEMPLATE',
    EMAIL_EDITOR_ADD_RECIPIENT: 'EMAIL_EDITOR_ADD_RECIPIENT',
    EMAIL_EDITOR_DELETE_RECIPIENT: 'EMAIL_EDITOR_DELETE_RECIPIENT',
    EMAIL_EDITOR_SELECTED_AUTO_TEXT_SUBJECT: 'EMAIL_EDITOR_SELECTED_AUTO_TEXT_SUBJECT',
    EMAIL_EDITOR_SELECTED_AUTO_TEXT_BODY: 'EMAIL_EDITOR_SELECTED_AUTO_TEXT_BODY',
    EMAIL_EDITOR_CREATE_TEMPLATE: 'EMAIL_EDITOR_CREATE_TEMPLATE',
    EMAIL_EDITOR_UPDATE_TEMPLATE: 'EMAIL_EDITOR_UPDATE_TEMPLATE',
    EMAIL_EDITOR_DELETE_TEMPLATE: 'EMAIL_EDITOR_DELETE_TEMPLATE',
    EMAIL_EDITOR_SEND_EMAIL: 'EMAIL_EDITOR_SEND_EMAIL',

    LINKEDIN_EDITOR_SELECT_TEMPLATE: 'LINKEDIN_EDITOR_SELECT_TEMPLATE',
    LINKEDIN_EDITOR_ADD_RECIPIENT: 'LINKEDIN_EDITOR_ADD_RECIPIENT',
    LINKEDIN_EDITOR_DELETE_RECIPIENT: 'LINKEDIN_EDITOR_DELETE_RECIPIENT',
    LINKEDIN_EDITOR_SELECTED_AUTO_TEXT_SUBJECT: 'LINKEDIN_EDITOR_SELECTED_AUTO_TEXT_SUBJECT',
    LINKEDIN_EDITOR_SELECTED_AUTO_TEXT_BODY: 'LINKEDIN_EDITOR_SELECTED_AUTO_TEXT_BODY',
    LINKEDIN_EDITOR_CREATE_TEMPLATE: 'LINKEDIN_EDITOR_CREATE_TEMPLATE',
    LINKEDIN_EDITOR_UPDATE_TEMPLATE: 'LINKEDIN_EDITOR_UPDATE_TEMPLATE',
    LINKEDIN_EDITOR_DELETE_TEMPLATE: 'LINKEDIN_EDITOR_DELETE_TEMPLATE',
    LINKEDIN_EDITOR_SEND_EMAIL: 'LINKEDIN_EDITOR_SEND_EMAIL',

    IN_MAIL_EDITOR_SELECT_TEMPLATE: 'IN_MAIL_EDITOR_SELECT_TEMPLATE',
    IN_MAIL_EDITOR_ADD_RECIPIENT: 'IN_MAIL_EDITOR_ADD_RECIPIENT',
    IN_MAIL_EDITOR_DELETE_RECIPIENT: 'IN_MAIL_EDITOR_DELETE_RECIPIENT',
    IN_MAIL_EDITOR_SELECTED_AUTO_TEXT_SUBJECT: 'IN_MAIL_EDITOR_SELECTED_AUTO_TEXT_SUBJECT',
    IN_MAIL_EDITOR_SELECTED_AUTO_TEXT_BODY: 'IN_MAIL_EDITOR_SELECTED_AUTO_TEXT_BODY',
    IN_MAIL_EDITOR_CREATE_TEMPLATE: 'IN_MAIL_EDITOR_CREATE_TEMPLATE',
    IN_MAIL_EDITOR_UPDATE_TEMPLATE: 'IN_MAIL_EDITOR_UPDATE_TEMPLATE',
    IN_MAIL_EDITOR_DELETE_TEMPLATE: 'IN_MAIL_EDITOR_DELETE_TEMPLATE',
    IN_MAIL_EDITOR_SEND_EMAIL: 'IN_MAIL_EDITOR_SEND_EMAIL',

    RECOMMENDATIONS_TOGGLE_TURN_ON: 'RECOMMENDATIONS_TOGGLE_TURN_ON',
    RECOMMENDATIONS_TOGGLE_TURN_OFF: 'RECOMMENDATIONS_TOGGLE_TURN_OFF',
    RECOMMENDATIONS_CHECKBOX_TURN_OFF: 'RECOMMENDATIONS_CHECKBOX_TURN_OFF',
    RECOMMENDATIONS_AI_PANEL_COLLAPSED: 'RECOMMENDATIONS_AI_PANEL_COLLAPSED',
    RECOMMENDATIONS_AI_PANEL_EXPANDED: 'RECOMMENDATIONS_AI_PANEL_EXPANDED',
    RECOMMENDATIONS_POPUP_APPLIED: 'RECOMMENDATIONS_POPUP_APPLIED',
    RECOMMENDATIONS_POPUP_DISMISSED: 'RECOMMENDATIONS_POPUP_DISMISSED',
    RECOMMENDATIONS_SLIDER_OPEN: 'RECOMMENDATIONS_SLIDER_OPEN',

    IMPORT_CANDIDATE_IN_QUALIFIED_TAB_VIA_LINKEDIN: 'IMPORT_CANDIDATE_IN_QUALIFIED_TAB_VIA_LINKEDIN',
};

export const TRACKING_OPTIONS_MAP = {
    positionId: 'position_id',
    positionName: 'position_name',
    originalPositionId: 'original_position_id',
    originalPositionName: 'original_position_name',
    positionDescription: 'position_description',
    candidateName: 'candidate_name',
    candidatesCount: 'candidates_count',
    talentId: 'talent_id',
    talentIds: 'talent_ids',
    linkedInUploaded: 'linked_in_uploaded',
    samplesCount: 'samples_count',
    predictionScore: 'likely_to_move_percentage',
    matchScore: 'likely_match',
    rejectReasons: 'reject_reasons',
    reason: 'reason',
    positionCreated: 'date_created',
    positionCreateMethod: 'uploaded_or_created_jd',
    positionOriginalTitle: 'position_name',
    positionTitle: 'position_name_added',
    positionTitleChanged: 'position_name_edit',
    hasLocationEdited: 'location_edit',
    isLocationMissing: 'location_missing',
    locationName: 'location',
    locationsList: 'locations_list',
    haveSimilarTitlesEdited: 'job_titles_of_similar_people_edit',
    similarTitlesAdded: 'job_titles_of_similar_people_added_amount',
    similarTitlesDeleted: 'job_titles_of_similar_people_deleted_amount',
    similarTitlesDeletedList: 'job_titles_of_similar_people_deleted',
    similarTitlesAddedList: 'job_titles_of_similar_people_added',
    similarTitlesCount: 'job_titles_of_similar_people_amount',
    similarTitlesList: 'job_titles_of_similar_people',
    similarTitlesExcludedCount: 'job_title_excluded_by_user_amount',
    similarTitlesExcludedList: 'job_title_excluded_by_user',
    regeneratedJobTitles: 'regenerated_job_titles',
    minYearsOfExp: 'years_of_experience_minimum_parsing_edit',
    hasMinYearsOfExpChanged: 'years_of_experience_maximum_parsing_edit',
    maxYearsOfExp: 'years_of_experience_minimum_parsing',
    hasMaxYearsOfExpChanged: 'years_of_experience_maximum_parsing_edit',
    hasMinSeniorityChanged: 'seniority_level_from_edit',
    hasMaxSeniorityChanged: 'seniority_level_to_edit',
    minSeniority: 'seniority_level_from',
    maxSeniority: 'seniority_level_to',
    hasEducationChanged: 'requested_education_edit',
    educationList: 'requested_education_level',
    educationDeleted: 'requested_education_deleted',
    educationAdded: 'requested_education_added',
    haveSpecialitiesChanged: 'preferred_specialties_edit',
    specialtiesAmount: 'preferred_specialties_amount',
    specialtiesList: 'preferred_specialties_list',
    specialtiesAdded: 'preferred_specialties_added',
    specialtiesDeleted: 'preferred_specialties_deleted',
    haveCompaniesChanged: 'preferred_companies_for_sourcing_edit',
    companiesToTrack: 'preferred_companies_for_sourcing',
    companiesToSkip: 'don\'t source from these companies',
    haveLanguagesChanged: 'must_have_language_proficiency_edit',
    languagesList: 'must_have_language_proficiency',
    derivedSkillsList: 'derived_skills',
    derivedSkillsCount: 'derived_skills_amount',

    filteredSkillsList: 'must_haves_skills',
    filteredSkillsCount: 'must_haves_skills_amount',
    filteredSkillsEdited: 'must_haves_skills_edit',
    filteredSkillsDeleted: 'must_haves_skills_deleted_amount',
    filteredSkillsAdded: 'must_haves_skills_added_amount',
    haveFilteredSkillsPriorityChanged: 'must_haves_skills_change_priority',

    mandatorySkillsList: 'important_skills',
    mandatorySkillsCount: 'important_skills_amount',
    mandatorySkillsEdited: 'important_skills_edit',
    mandatorySkillsDeleted: 'important_skills_deleted_amount',
    mandatorySkillsAdded: 'important_skills_added_amount',
    haveMandatorySkillsPriorityChanged: 'important_skills_change_priority',

    preferredSkillsList: 'preferred_skills',
    preferredSkillsCount: 'preferred_skills_amount',
    preferredSkillsEdited: 'preferred_skills_edit',
    preferredSkillsDeleted: 'preferred_skills_deleted_amount',
    preferredSkillsAdded: 'preferred_skills_added_amount',
    havePreferredSkillsPriorityChanged: 'preferred_skills_change_priority',

    optionalSkillsList: 'advantage_skills',
    optionalSkillsCount: 'advantage_skills_amount',
    optionalSkillsEdited: 'advantage_skills_edit',
    optionalSkillsDeleted: 'advantage_skills_deleted_amount',
    optionalSkillsAdded: 'advantage_skills_added_amount',
    haveOptionalSkillsPriorityChanged: 'advantage_skills_change_priority',

    problematicSkills: 'problematic_skills',
    problematicSkillsCount: 'problematic_skills_amount',

    originalSearchDiversityPercentage: 'diversity_original_percentage',
    optimizedSearchDiversityPercentage: 'diversity_optimized_percentage',
    diversityType: 'diversity_type',

    campaignPrevName: 'campaign_prev_name',
    campaignName: 'campaign_name',
    campaignPrevSenderEmail: 'campaign_prev_sender_email',
    campaignSenderEmail: 'campaign_sender_email',
    campaignPrevSenderRole: 'campaign_prev_sender_role',
    campaignSenderRole: 'campaign_sender_role',
    campaignCopyEmailsPositionId: 'campaign_copy_emails_position_id',
    isDefaultCampaign: 'is_default_campaign',
    campaignEmailChannel: 'campaign_email_channel',

    filterType: 'filter_type',
    totalNumber: 'total_number',
    workflowStep: 'workflow_step',
};

export const USER_OPTIONS_MAP = {
    userLoginType: 'user_login',
    employerRepId: 'employer_rep_id',
    created: 'created',
    employerId: 'employer_id',
    employerName: 'employer_name',
    roleType: 'role_type',
    fullName: 'full_name',
    office: 'employer_sales_status',
    isTalenyaUser: 'is_talenya_user',
    name: '$name',
    email: '$email',
};

export const REJECTION_REASONS_MAP = {
    NO_REASON: 'no reason',
    [REJECTION_REASONS_FEEDBACK.JOB_TITLE]: 'job title',
    [REJECTION_REASONS_FEEDBACK.SKILLS]: 'skills',
    [REJECTION_REASONS_FEEDBACK.EMPLOYER]: 'company',
    [REJECTION_REASONS_FEEDBACK.INDUSTRY]: 'specialties/industries',
    [REJECTION_REASONS_FEEDBACK.LOCATION]: 'location',
    [REJECTION_REASONS_FEEDBACK.RELEVANT_EXPERIENCE]: 'years of experience',
    [REJECTION_REASONS_FEEDBACK.SENIORITY]: 'seniority',
    [REJECTION_REASONS_FEEDBACK.EDUCATION]: 'education',
    [REJECTION_REASONS_FEEDBACK.LANGUAGES]: 'language',
    [REJECTION_REASONS_FEEDBACK.LACK_OF_INFORMATION]: 'not enough data',
    [REJECTION_REASONS_FEEDBACK.OTHER]: 'other',
    [REJECTION_REASONS_FEEDBACK.ALREADY_REVIEWED]: 'already reviewed',
    [REJECTION_REASONS_FEEDBACK.PREVIOUS_JOB_TITLES]: 'previous job title',
    [REJECTION_REASONS_FEEDBACK.MANAGERIAL_EXPERIENCE]: 'managerial experience',
    [REJECTION_REASONS_FEEDBACK.AVERAGE_TENURE]: 'average tenure',
    [REJECTION_REASONS_FEEDBACK.COMPANY_SIZE]: 'company size',
    [REJECTION_REASONS_FEEDBACK.SCHOOLS]: 'schools',
};
